import { useEffect, useState } from 'react';

import fontStyles from 'styles/Fonts.module.scss';
import { postRating } from 'api/api';
import Star from 'components/blog/banner/star';
import styles from 'styles/Banner.module.scss';
import { usePageInfo } from 'context/PageInfoContext';
import { useTranslations } from 'next-intl';

const StarContainer = () => {
    const { pageInfo } = usePageInfo();
    const [rateValue, setRateValue] = useState(null);
    const [rateSent, setRateSent] = useState(false);
    const [active, setActive] = useState(false);
    const [activeValue, setActiveValue] = useState(0);
    const pageRating = Number(pageInfo.page_context.page_rating_avg);
    const pageRatingCount = Number(pageInfo.page_context.page_rating_count);
    const t = useTranslations('banner');

    const updateRateValue = (newState) => {
        if (rateSent) {
            return;
        }
        setRateValue(newState);
        setRateSent(true);
    };

    useEffect(() => {
        // Using useEffect to add new rating
        if (rateValue === null) {
            return;
        }

        const payload = {
            object_code: pageInfo.page_context.code,
            object_name: pageInfo.page_context.is_remote ? 'page_remote' : 'page_page',
            rating: rateValue
        };

        postRating(payload);

        setRateSent(true);
    }, [rateValue]);

    const starItems = [];
    for (const i of Array(5).keys()) {
        starItems.push(
            <Star
                key={i}
                filled={pageRating > i}
                onClick={updateRateValue}
                rateSent={rateSent}
                rateValue={i + 1}
                setActive={setActive}
                setActiveValue={setActiveValue}
                activeValue={activeValue}
                active={active}
            />
        );
    }

    return (
        <div
            className={styles.container}
            itemProp="aggregateRating"
            itemScope
            itemType="http://schema.org/AggregateRating"
        >
            <div className={styles.star_container}>{starItems}</div>
            {pageRatingCount > 0 && (
                <div className={styles.description}>
                    <meta itemProp="worstRating" content={t('worst-rating')} />
                    <meta itemProp="bestRating" content={t('best-rating')} />
                    <span className={`${fontStyles.text_small} ${styles.hide_mobile}`}>{t('score')}</span>
                    <span
                        itemProp="ratingValue"
                        className={fontStyles.text_small}
                    >
                        {pageRating}
                    </span>
                    <span className={fontStyles.text_small}>{`/ 5 ${t('of')}`}</span>
                    <span
                        itemProp="ratingCount"
                        className={fontStyles.text_small}
                    >
                        {pageRatingCount}
                    </span>
                </div>
            )}
        </div>
    );
};

export default StarContainer;
